import { render, staticRenderFns } from "./documentEmailFetcher.vue?vue&type=template&id=232afa62&scoped=true"
import script from "./documentEmailFetcher.vue?vue&type=script&lang=js"
export * from "./documentEmailFetcher.vue?vue&type=script&lang=js"
import style0 from "./documentEmailFetcher.vue?vue&type=style&index=0&id=232afa62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232afa62",
  null
  
)

export default component.exports